























import Vue from 'vue';
import Card from '~/components/profile/cards/Card.vue';
import { CandidateStudyProgram } from '~/services/CSPService';
import { commonProps } from '~/utils/candidate';
import StudyProgramDetails from '../components/StudyProgramDetails.vue';
import StudyProgramsModal from '../modals/StudyProgramsModal.vue';

export default Vue.extend({
    name: 'StudyPrograms',
    components: {
        Card,
        StudyProgramsModal,
        StudyProgramDetails,
    },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        hasNoStudyPrograms(): boolean {
            return !this.candidate.studyPrograms.length;
        },
        cardTitle(): string {
            return this.hasNoStudyPrograms
                ? this.$t('profile.studyPrograms.titleWhenEmpty').toString()
                : this.$t('profile.studyPrograms.title').toString();
        },
        programs(): CandidateStudyProgram[] {
            return [...this.candidate.studyPrograms].sort(
                (a, b) => a.start.getTime() - b.start.getTime()
            );
        },
    },
});
